<template>
  <div class="shift-template-manager">
    <div class="template-desktop-list">
      <div class="template-grid template-grid--head">
        <div class="template-cell">Название</div>
        <div class="template-cell">Паттерн</div>
        <div class="template-cell">Перерывы</div>
        <div class="template-cell">Действия</div>
      </div>

      <template v-if="templates.length">
        <div v-for="template in templates" :key="template.id" class="template-grid template-grid--row">
          <div class="template-cell template-cell--accent">{{ template.name }}</div>
          <div class="template-cell template-cell--accent">{{ getPatternLabel(template.pattern) }}</div>
          <div class="template-cell template-cell--accent">{{ getBreaksLabel(template.breaks) }}</div>
          <div class="template-cell template-cell--actions">
            <div class="template-actions">
              <el-button
                type="primary"
                size="small"
                :icon="EditPen"
                circle
                @click="openDialog(template)"
              />
              <el-button
                type="danger"
                size="small"
                :icon="Delete"
                circle
                :loading="deletingId === template.id"
                @click="confirmRemoveTemplate(template)"
              />
            </div>
          </div>
        </div>
      </template>

      <div v-else class="empty-table">
        Пока нет шаблонов. Нажмите "Создать шаблон", чтобы добавить первый.
      </div>
    </div>

    <div class="template-mobile-list">
      <template v-if="templates.length">
        <article v-for="template in templates" :key="`mobile-${template.id}`" class="template-mobile-card">
          <div class="template-mobile-pill template-mobile-pill--name">{{ template.name }}</div>
          <div class="template-mobile-pill template-mobile-pill--pattern">{{ getPatternLabel(template.pattern) }}</div>
          <div class="template-mobile-pill template-mobile-pill--breaks">{{ getBreaksLabel(template.breaks) }}</div>
          <div class="template-mobile-pill template-mobile-pill--actions">
            <div class="template-actions">
              <el-button
                type="primary"
                size="small"
                :icon="EditPen"
                circle
                @click="openDialog(template)"
              />
              <el-button
                type="danger"
                size="small"
                :icon="Delete"
                circle
                :loading="deletingId === template.id"
                @click="confirmRemoveTemplate(template)"
              />
            </div>
          </div>
        </article>
      </template>
      <div v-else class="empty-table">
        Пока нет шаблонов. Нажмите "Создать шаблон", чтобы добавить первый.
      </div>
    </div>

    <el-button class="create-template-btn" type="primary" @click="openDialog()">Создать шаблон</el-button>

    <el-dialog v-model="dialogVisible" title="Шаблон смены" width="500px">
      <el-form :model="form" :rules="rules" ref="formRef" label-width="0">
        <el-form-item prop="name">
          <el-input v-model="form.name" placeholder="Название шаблона" />
        </el-form-item>
        <el-form-item prop="pattern">
          <el-select v-model="form.pattern" placeholder="Паттерн">
            <el-option label="5/2 (пн–пт, сб–вс выходные)" value="5_2" />
            <el-option label="2/2 (2 рабочих, 2 выходных)" value="2_2" />
            <el-option label="3/3 (3 рабочих, 3 выходных)" value="3_3" />
            <el-option label="1/3 (сутки через трое)" value="1_3" />
            <el-option label="1/2 (сутки через двое)" value="1_2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="breaks-container">
            <el-button
              type="success"
              size="small"
              @click="addBreak"
              class="break-add-btn">
              Добавить перерыв
            </el-button>
            <div class="break-row">
              <template v-for="(br, idx) in form.breaks" :key="idx">
                <el-select v-model="br.type" placeholder="Тип перерыва" class="break-select">
                  <el-option label="Обед" value="lunch" />
                  <el-option label="Перерыв" value="break" />
                  <el-option label="Тех.перерыв" value="maintenance" />
                  <el-option label="Смена" value="handover" />
                </el-select>
                <el-time-select v-model="br.start_time" :start="'00:00'" :end="'23:59'" step="00:15" placeholder="Начало" class="break-time" />
                <el-time-select v-model="br.end_time" :start="br.start_time || '00:00'" :end="'23:59'" step="00:15" placeholder="Конец" class="break-time" />
                <el-button type="danger" :icon="Delete" circle @click="confirmRemoveBreak(idx)" />
              </template>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">Отмена</el-button>
        <el-button type="primary" @click="saveTemplate">Сохранить</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { Delete, EditPen } from '@element-plus/icons-vue'
import { mapActions } from 'vuex'

export default {
  name: "ShiftTemplateManager",
  computed: {
    EditPen() {
      return EditPen
    },
    Delete() {
      return Delete
    },
    templates() {
      return this.$store.state.schedules.schedulesTemplates || []
    }
  },
  props: {
    modelValue: { type: Array, default: () => [] }
  },
  data() {
    return {
      dialogVisible: false,
      form: { id: null, name: "", pattern: "", breaks: [] },
      rules: {
        name: [
          { required: true, message: 'Пожалуйста, введите название шаблона', trigger: 'blur' }
        ],
        pattern: [
          { required: true, message: 'Пожалуйста, выберите паттерн', trigger: 'change' }
        ],
      },
      deletingId: null,
    }
  },
  methods: {
    ...mapActions('schedules', ['fetchScheduleTemplates', 'saveScheduleTemplate', 'deleteScheduleTemplates']),
    getBreakIcon(type) {
      switch (type) {
        case "lunch": return "🍽️"
        case "break": return "⏸️"
        case "maintenance": return "🛠️"
        case "handover": return "🔁"
        default: return "⏹️"
      }
    },
    getBreaksLabel(breaks) {
      if (!Array.isArray(breaks) || !breaks.length) return '—'
      return breaks
        .map(br => `${br.start_time}–${br.end_time}`)
        .join(', ')
    },
    openDialog(template = null) {
      this.form = template
        ? JSON.parse(JSON.stringify(template))
        : { id: null, name: "", pattern: "", breaks: [] }
      this.dialogVisible = true
    },
    async saveTemplate() {
      await this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        await this.saveScheduleTemplate(this.form)
        this.$message.success('Шаблон сохранён')
        this.dialogVisible = false
      })
    },
    async confirmRemoveTemplate(row) {
      try {
        await this.$confirm('Удалить этот шаблон?', 'Подтверждение', {
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
          type: 'warning',
        })
        this.deletingId = row.id
        await this.deleteScheduleTemplates(row.id)
        this.$message.success('Шаблон удалён')
      } catch (e) {
        // cancelled or failed — do nothing
      } finally {
        this.deletingId = null
      }
    },
    confirmRemoveBreak(idx) {
      this.$confirm('Удалить этот перерыв?', 'Подтверждение', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'warning',
      }).then(() => {
        this.form.breaks.splice(idx, 1)
      }).catch(() => {})
    },
    async removeTemplate(id) {
      await this.deleteScheduleTemplates(id);
    },
    getPatternLabel(value) {
      switch (value) {
        case "5_2": return "5/2 (пн–пт, сб–вс выходные)"
        case "2_2": return "2/2 (2 рабочих, 2 выходных)"
        case "3_3": return "3/3 (3 рабочих, 3 выходных)"
        case "1_3": return "1/3 (сутки через трое)"
        case "1_2": return "1/2 (сутки через двое)"
        default: return value
      }
    },
    addBreak() {
      // Проверяем только на "обед"
      const existingLunch = this.form.breaks.some(b => b.type === 'lunch')
      if (existingLunch) {
        // Если добавляется ещё один lunch — предупреждаем
        this.form.breaks.push({ type: 'break', start_time: '', end_time: '' })
        return
      }
      // По умолчанию добавляем lunch первым, если его ещё нет
      this.form.breaks.push({ type: 'lunch', start_time: '', end_time: '' })
    }
  },
  mounted() {
    this.fetchScheduleTemplates()
  }
}
</script>

<style scoped>
.shift-template-manager {
  color: var(--cal-text-inverse);
}

.template-desktop-list {
  display: block;
}

.template-grid {
  display: grid;
  grid-template-columns: 25.7fr 33.1fr 23.6fr 18fr;
  gap: 12px;
  padding: 0 6px;
  box-sizing: border-box;
}

.template-grid + .template-grid {
  margin-top: 9px;
}

.template-cell {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px;
  text-align: center;
  border-radius: 8px;
  font-family: var(--ui-font-family-base) !important;
}

.template-grid--head .template-cell {
  background:
    linear-gradient(rgb(0 108 254 / 22%), rgb(0 108 254 / 22%)),
    linear-gradient(180deg, #15264e 0%, #030b1b 100%) !important;
  box-shadow: none !important;
  color: #ffffff !important;
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
  min-height: 54px;
}

.template-grid--row .template-cell {
  background:
    linear-gradient(180deg, rgba(20, 37, 76, 0.82) 0%, rgba(3, 11, 27, 0.98) 100%) !important;
  box-shadow: inset 0 0 0 1px rgba(24, 49, 97, 0.95) !important;
  color: #ffffff !important;
  font-size: 16px;
}

.template-cell--accent {
  color: #00c3fe !important;
}

.template-cell--actions {
  padding: 0 12px;
}

.template-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
}

.template-mobile-list {
  display: none;
}

.template-mobile-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.template-mobile-card + .template-mobile-card {
  margin-top: 12px;
}

.template-mobile-pill {
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  border-radius: 10px;
  background: #0c224b !important;
  box-shadow: inset 0 0 0 1px rgba(74, 106, 173, 0.08) !important;
  color: #00c3fe !important;
  text-align: center;
  font-family: var(--ui-font-family-base) !important;
  font-size: 14px;
}

.create-template-btn {
  margin: 34px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 205px;
  min-height: 42px;
  border-radius: 9px;
  font-size: 18px;
  font-family: var(--ui-font-family-base) !important;
  font-weight: 700;
  white-space: nowrap;
}

.shift-template-manager :deep(.el-button--primary:not(.is-plain)) {
  background: var(--appointment-primary);
  border-color: transparent;
  color: var(--appointment-primary-text);
}

.shift-template-manager :deep(.el-button--success) {
  background: var(--appointment-primary);
  border-color: transparent;
  color: var(--appointment-primary-text);
}

.shift-template-manager :deep(.el-button--danger) {
  background: var(--appointment-control);
  border-color: transparent;
  color: #ff8d8d;
}

.shift-template-manager :deep(.el-dialog) {
  background: var(--appointment-panel);
  border: 1px solid var(--cal-border);
  box-shadow: var(--cal-shadow-card);
}

.shift-template-manager :deep(.el-dialog__header),
.shift-template-manager :deep(.el-dialog__body),
.shift-template-manager :deep(.el-dialog__footer) {
  background: transparent;
}

.shift-template-manager :deep(.el-dialog__title) {
  color: var(--cal-text-inverse);
}

.shift-template-manager :deep(.el-input__wrapper),
.shift-template-manager :deep(.el-select__wrapper),
.shift-template-manager :deep(.el-time-editor.el-input__wrapper) {
  background: var(--appointment-value);
  box-shadow: 0 0 0 1px var(--cal-border) inset;
}

.shift-template-manager :deep(.el-input__inner),
.shift-template-manager :deep(.el-select__placeholder),
.shift-template-manager :deep(.el-select__selected-item) {
  color: var(--cal-text-inverse);
}

.shift-template-manager :deep(.el-button--default) {
  background: var(--appointment-secondary);
  border-color: transparent;
  color: var(--appointment-secondary-text);
}

.breaks-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  padding: 8px 0;
  max-width: 100%;
}

/* Make .break-row take full width and distribute columns */
.break-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 6px;
  align-items: center;
  width: 100%;
}

.break-select {
  /* Remove min-width and max-width, expand to grid cell */
  width: 100%;
}

.break-time {
  /* Remove min-width and max-width, expand to grid cell */
  width: 100%;
}

.break-add-btn {
  align-self: flex-start;
}

.empty-table {
  text-align: center;
  padding: 36px 20px 0;
  color: var(--cal-text-muted);
}

@media (max-width: 768px) {
  .template-desktop-list {
    display: none;
  }

  .template-mobile-list {
    display: block;
  }

  .shift-template-manager :deep(.el-dialog) {
    width: calc(100vw - 24px) !important;
  }

  .create-template-btn {
    margin-top: 18px;
  }

  .break-row {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
}

@media (max-width: 480px) {
  .shift-template-manager :deep(.el-dialog) {
    width: calc(100vw - 12px) !important;
  }

  .create-template-btn {
    width: 184px;
    min-height: 38px;
  }

  .break-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  .break-select, .break-time {
    width: 100% !important;
  }
}
</style>

